export enum ButtonTypes {
  BUY,
  DETAIL,
  REQUEST_PRICE,
  NOT_AVAILABLE,
}
